import React from "react";
import { Box, Stack, styled, Typography } from "@mui/material";
import Link from "@mui/material/Link";
import { Link as RouterLink } from "react-router-dom";
// import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import FooterTitle from "./FooterTitle";
import { useTranslation } from "react-i18next";
import { APP_VERSION } from "../../version";

// Icono de TikTok personalizado
const TikTokIcon = ({ sx }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    sx={sx}
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);

const Footer = () => {
  const { t } = useTranslation();
  const internalLinks = [
    { to: "/", label: "Inicio - IA y GEO" },
    { to: "/peoplefortech/v2", label: "Asesoramiento e Implementación IA" },
    { to: "/geo-para-chatgpt-gemini", label: "Servicio GEO para ChatGPT y Gemini" },
    { to: "/blog", label: "Blog y recursos de IA" },
    { to: "/contact", label: "Contacto consultoría IA" },
    { to: "/about", label: "Acerca de PeopleForTech" },
    { to: "/peoplefortech/v2/reserva", label: "Reserva sesión estratégica IA" },
    { to: "/terms-of-service", label: "Términos del servicio" },
    { to: "/privacy-policy", label: "Política de privacidad" }
  ];

  const StackColumn = styled(Stack)(() => ({
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    flex: 1,
    gap: 8,
    textAlign: "center",
  }));

  const BoxRow = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    backgroundColor: "transparent",
    flex: 1,
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: 30,
    },
  }));

  return (
    <Box
      component="footer"
      sx={{
        py: 4,
        px: 2,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 3,
      }}
    >
      <BoxRow sx={{ width: "100%", justifyContent: "center" }}>
        <StackColumn>
          <FooterTitle text={t("footer.followUs")} />
          <Stack direction="row" spacing={2} justifyContent="center" alignItems="center">
            <Link
              href="https://www.tiktok.com/@peoplefortech"
              target="_blank"
              rel="noopener noreferrer"
              variant="body2"
              sx={{
                color: "#414141",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "&:hover": {
                  color: "#1c2859",
                },
              }}
            >
              <TikTokIcon />
            </Link>
            <Link
              href="https://www.instagram.com/people_for_tech/"
              target="_blank"
              rel="noopener noreferrer"
              variant="body2"
              sx={{
                color: "#414141",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "&:hover": {
                  color: "#E4405F",
                },
              }}
            >
              <InstagramIcon sx={{ fontSize: 24 }} />
            </Link>
            {/* LinkedIn comentado
            <Link
              href="https://www.linkedin.com/in/people-for-tech"
              target="_blank"
              rel="noopener noreferrer"
              variant="body2"
              sx={{
                color: "#414141",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "&:hover": {
                  color: "#0077b5",
                },
              }}
            >
              <LinkedInIcon sx={{ fontSize: 24 }} />
            </Link>
            */}
          </Stack>
        </StackColumn>

        <StackColumn>
          <Typography variant="caption" component="p" sx={{ color: "#414141" }}>
            {t("footer.copyright")}
          </Typography>
        </StackColumn>
      </BoxRow>

      <Box sx={{ width: "100%", maxWidth: 980, textAlign: "center" }}>
        <Typography
          variant="body2"
          component="h2"
          sx={{ color: "#202020", fontWeight: 600, mb: 1 }}
        >
          Enlaces internos clave
        </Typography>
        <Stack
          direction="row"
          spacing={1.5}
          useFlexGap
          flexWrap="wrap"
          justifyContent="center"
          sx={{ px: 1 }}
        >
          {internalLinks.map((item) => (
            <Link
              key={item.to}
              component={RouterLink}
              to={item.to}
              underline="hover"
              sx={{
                color: "#2a2a2a",
                fontSize: "0.9rem",
                "&:hover": { color: "#1c2859" }
              }}
            >
              {item.label}
            </Link>
          ))}
        </Stack>
      </Box>

      {/* Versión siempre abajo de todo - se incrementa en cada deploy */}
      <Typography
        variant="caption"
        component="p"
        sx={{ color: "#999", fontSize: "0.7rem", mt: 1 }}
      >
        v{APP_VERSION}
      </Typography>
    </Box>
  );
};

export default Footer;
